module.exports = __webpack_public_path__ + "static/hero-4f17a444f31a217157a66b2e7ee74564.jpg";